import styled from 'styled-components';
import spinnerSvg from '@assets/spinner.svg?url';

interface LoaderProps {
	width?: number;
	height?: number;
}

const StyledLoader = styled.div<LoaderProps>`
	width: ${({ width = 32 }) => width}px;
	height: ${({ height = 32 }) => height}px;

	// enable hardware acceleration to make animated SVG render at high framerate
	transform: translateZ(0);
	backface-visibility: hidden;
	perspective: 1000;
	will-change: transform;

	// found this at https://icons8.com/preloaders/en/search/moon%20loading
	// customized the "Half moon" loading spinner
	background-image: url(${spinnerSvg});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
`;

export const Loader = ({ width, height }: LoaderProps) => {
	return <StyledLoader width={width} height={height} />;
};
